/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

const Step5View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const BooleanField: React.FC<{ label: string; value: boolean | null }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Chip
                label={value === true ? 'Sim' : value === false ? 'Não' : 'Não informado'}
                color={value === true ? 'success' : value === false ? 'error' : 'default'}
                size="small"
            />
        </Box>
    );

    const equipamentosInfraestrutura = [
        { label: 'Prédio Próprio', possui: formulario.possui_predio_proprio, quantidade: formulario.quantidade_predio_proprio },
        { label: 'Salas', possui: formulario.possui_salas, quantidade: formulario.quantidade_salas },
        { label: 'Auditório', possui: formulario.possui_auditorio, quantidade: formulario.quantidade_auditorio },
    ];

    const equipamentosInformatica = [
        { label: 'Computador', possui: formulario.possui_computador, quantidade: formulario.quantidade_computador },
        { label: 'Notebook', possui: formulario.possui_notebook, quantidade: formulario.quantidade_notebook },
        { label: 'Tablet', possui: formulario.possui_tablet, quantidade: formulario.quantidade_tablet },
        { label: 'Impressora', possui: formulario.possui_impressora, quantidade: formulario.quantidade_impressora },
    ];

    const equipamentosTecnicos = [
        { label: 'Receptor GPS Navegação', possui: formulario.possui_receptor_gps_navegacao, quantidade: formulario.quantidade_receptor_gps_navegacao },
        { label: 'Receptor GPS Geodésico', possui: formulario.possui_receptor_gps_geodesico, quantidade: formulario.quantidade_receptor_gps_geodesico },
        { label: 'Equipamento Coleta de Solo', possui: formulario.possui_equipamento_coleta_solo, quantidade: formulario.quantidade_equipamento_coleta_solo },
    ];

    const veiculos = [
        { label: 'Veículo Popular', possui: formulario.possui_veiculo_popular, quantidade: formulario.quantidade_veiculo_popular },
        { label: 'Caminhonete', possui: formulario.possui_veiculo_caminhonete, quantidade: formulario.quantidade_veiculo_caminhonete },
        { label: 'SUV', possui: formulario.possui_veiculo_suv, quantidade: formulario.quantidade_veiculo_suv },
        { label: 'Motocicleta', possui: formulario.possui_veiculo_motocicleta, quantidade: formulario.quantidade_veiculo_motocicleta },
    ];

    const caminhoes = [
        { label: 'Caminhão Caçamba', possui: formulario.possui_caminhao_cacamba, quantidade: formulario.quantidade_caminhao_cacamba },
        { label: 'Caminhão Baú sem Refrigeração', possui: formulario.possui_caminhao_bau_sem_refrigeracao, quantidade: formulario.quantidade_caminhao_bau_sem_refrigeracao },
        { label: 'Caminhão Baú Refrigerado', possui: formulario.possui_caminhao_bau_refrigerado, quantidade: formulario.quantidade_caminhao_bau_refrigerado },
        { label: 'Caminhão com Tanque Isotérmico', possui: formulario.possui_caminhao_com_tanque_isotermico, quantidade: formulario.quantidade_caminhao_com_tanque_isotermico },
        { label: 'Caminhão Carga Seca', possui: formulario.possui_caminhao_carga_seca, quantidade: formulario.quantidade_caminhao_carga_seca },
    ];

    const maquinasAgricolas = [
        { label: 'Trator até 14cv', possui: formulario.possui_trator_14cv, quantidade: formulario.quantidade_trator_14cv },
        { label: 'Trator até 50cv', possui: formulario.possui_trator_50cv, quantidade: formulario.quantidade_trator_50cv },
        { label: 'Trator até 75cv', possui: formulario.possui_trator_75cv, quantidade: formulario.quantidade_trator_75cv },
        { label: 'Trator até 110cv', possui: formulario.possui_trator_110cv, quantidade: formulario.quantidade_trator_110cv },
        { label: 'Implementos Agrícolas Diversos', possui: formulario.possui_implementos_agricolas_diversos, quantidade: formulario.quantidade_implementos_agricolas_diversos },
        { label: 'Retroescavadeira', possui: formulario.retroescavadeira, quantidade: formulario.quantidade_retroescavadeira },
        { label: 'Escavadeira Hidráulica', possui: formulario.escavadeira_hidraulica, quantidade: formulario.quantidade_escavadeira_hidraulica },
        { label: 'Pá Carregadeira', possui: formulario.pa_carregadeira, quantidade: formulario.quantidade_pa_carregadeira },
        { label: 'Viveiro Produção de Mudas', possui: formulario.viveiro_producao_mudas, quantidade: formulario.quantidade_viveiro_producao_mudas },
    ];

    const EquipmentTable: React.FC<{ data: any[], title: string }> = ({ data, title }) => (
        <Box mb={3}>
            <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                {title}
            </Typography>
            <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell sx={{ width: '60%' }}><strong>Equipamento/Item</strong></TableCell>
                            <TableCell align="center" sx={{ width: '20%' }}><strong>Possui</strong></TableCell>
                            <TableCell align="center" sx={{ width: '20%' }}><strong>Quantidade</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ width: '60%' }}>{item.label}</TableCell>
                                <TableCell align="center" sx={{ width: '20%' }}>
                                    <Chip
                                        label={item.possui === true ? 'Sim' : 'Não'}
                                        color={item.possui === true ? 'success' : 'error'}
                                        size="small"
                                    />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '20%' }}>
                                    {item.quantidade || '0'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Estrutura
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <EquipmentTable data={equipamentosInfraestrutura} title="Infraestrutura" />
                </Grid>

                <Grid item xs={12}>
                    <EquipmentTable data={equipamentosInformatica} title="Equipamentos de Informática" />
                </Grid>

                <Grid item xs={12}>
                    <EquipmentTable data={equipamentosTecnicos} title="Equipamentos Técnicos" />
                </Grid>

                <Grid item xs={12}>
                    <EquipmentTable data={veiculos} title="Veículos Leves" />
                </Grid>

                <Grid item xs={12}>
                    <EquipmentTable data={caminhoes} title="Caminhões" />
                </Grid>

                <Grid item xs={12}>
                    <EquipmentTable data={maquinasAgricolas} title="Máquinas e Equipamentos Agrícolas" />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Step5View; 